import { render, staticRenderFns } from "./CircleStatistic.vue?vue&type=template&id=06a4e6b1"
import script from "./CircleStatistic.vue?vue&type=script&lang=js"
export * from "./CircleStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports